import { render } from "./DocumentManager.vue?vue&type=template&id=626c093b&scoped=true"
import script from "./DocumentManager.vue?vue&type=script&lang=js"
export * from "./DocumentManager.vue?vue&type=script&lang=js"

import "./DocumentManager.vue?vue&type=style&index=0&id=626c093b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-626c093b"]])

export default __exports__